import { getStore } from '../utils/storeHandler';
import { translate, showMessageToastCustom, networkConnectionOffline } from '../utils/util';
import PickingService from '../services/PickingService';
import { getVision, isAuthenticated } from '../services/auth';

class navigatorObserver {
    static onNavigatorOnline = () => {
        if (isAuthenticated()) {
            const store = getStore();
            const vision = getVision();
            // eslint-disable-next-line max-len
            showMessageToastCustom(translate('warning', 'general'), 'Olá! Sistema online. Ações pendentes poderão ser sincronzadas nesse momento.', 8000, 'mdi mdi-information-outline blue-text');// second-text-color
            store.dispatch(PickingService.pickingSync(vision));
            store.dispatch(PickingService.repickingSync(vision));
        }
    }

    static onNavigatorOffline = () => {
        networkConnectionOffline();
    }

    static onNavigatorLoad = () => {
    }

    static register = () => {
        window.addEventListener('online', this.onNavigatorOnline);
        // window.addEventListener('offline', this.onNavigatorOffline);
        window.addEventListener('load', this.onNavigatorLoad);
    }

    static unregister = () => {
        window.removeEventListener('online', this.onNavigatorOnline);
        // window.removeEventListener('offline', this.onNavigatorOffline);
        window.removeEventListener('load', this.onNavigatorLoad);
    }
}

export default navigatorObserver;
